import { useTranslation } from "react-i18next";
import { CloseOutlined } from "@ant-design/icons";
import { Drawer, Form } from "antd";

/**
 * TODO: Remove these dependencies from outside components
 * or bring them inside the components folder where applicable
 */
import { Descriptions } from "@av/components/atoms/descriptions/Descriptions";
import { Select } from "@av/components/atoms/Select";
import { Typography } from "@av/components/atoms/typography/Typography";
import { useSupportedLanguages } from "@av/config/i18n/locale-config";
import { useLocaleStore } from "@av/utils/hooks/useLocaleStore";
import { type Locale } from "./type";

type SettingsDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

function SettingsDrawer(props: SettingsDrawerProps) {
  const { isOpen, onClose } = props;
  const { t } = useTranslation();
  const { Title } = Typography;
  const [form] = Form.useForm();
  const supportedLanguages = useSupportedLanguages();
  const { locale, setLocale } = useLocaleStore();

  const handleLanguageChange = (value: Locale) => {
    setLocale(value);
  };

  return (
    <Drawer
      title={t("common.components.organisms_settingsDrawer_title")}
      placement="right"
      onClose={onClose}
      open={isOpen}
      width={400}
      data-testid="settings-drawer"
      closeIcon={<CloseOutlined data-testid="settings-drawer-close-button" />}
    >
      <Title testIdPrefix="settings-drawer-language" level={5}>
        {t("common.components.organisms_settingsDrawer_languageAndRegion")}
      </Title>
      <Form form={form} layout="vertical">
        <Descriptions
          testIdPrefix="settings-drawer"
          bordered
          colon={false}
          column={1}
          size="small"
          items={[
            {
              label: t("common.components.organisms_settingsDrawer_language"),
              testIdPrefix: "language",
              styles: { label: { width: "50%" } },
              children: (
                <Select
                  testIdPrefix="language"
                  value={locale}
                  onChange={handleLanguageChange}
                  options={supportedLanguages}
                  style={{ width: "100%" }}
                />
              ),
            },
          ]}
        />
      </Form>
    </Drawer>
  );
}

export { SettingsDrawer };
